module.exports = __webpack_public_path__ + "img/t1-b1.79df7c96.gif";